import { TemplatePreview } from 'framework/markdownEditor';
import React from 'react';

interface OfferTemplatePreviewProps {
  html: string;
}

const OfferTemplatePreview: React.FC<OfferTemplatePreviewProps> = ({ html }) => {
  return <TemplatePreview html={html} title="Preview" />;
};

export default OfferTemplatePreview;
